import { Component } from 'react';
import { connect } from 'react-redux';
import IgniteDataTable from '../../../common/datatable';
import { history } from '../../../../store';
import { downloadStockIt } from '../../../../actions/stock-it';

class StockItList extends Component {
  download(id) {
    this.props.dispatch(downloadStockIt(id));
  }

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'groups-linked',
        title: 'Groups Linked',
        width: '200'
      },
      {
        prop: 'active',
        title: 'Active',
        width: '100'
      }
    ];

    const actions = [
      {
        label: 'Details',
        callback: (row) => {
          history.push(`/admin/objectives/stock-it/${row.id}`);
        }
      },
      {
        label: 'Download',
        color: 'grey',
        callback: (row) => {
          this.download(row.id);
        }
      }
    ];
    return (
      <IgniteDataTable
        data={this.props.stockIts}
        hasAttributes
        columns={columns}
        actions={actions}
        hideId={false}
        remote
      />
    );
  }
}

export default connect()(StockItList);
